// PluginContract_ParagraphIndentPlugin.ts
export const ParagraphIndentContract = {
  pluginName: 'ParagraphIndentPlugin',
  nodeTypes: ['ParagraphNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('ParagraphNode');
    console.log('🔌 [ParagraphIndentPlugin] Registered ParagraphNode');
  },
};